import blue from "@material-ui/core/colors/blue";

import green from "@material-ui/core/colors/green";
import red from "@material-ui/core/colors/red";
import { createMuiTheme } from "@material-ui/core/styles";

// const drawerWidth = 256;

export const colors = {
  primary: "#1e6495",
  primaryDark: "#0a4b75",
  primaryLight: "#5191c1",

  drawer: "#0a4b75",
  scroll: "#fb6f24",
  logo: "#000",

  lightBlue: blue[300],
  blue: blue[500],
  darkBlue: blue[800],
  lightGreen: green[300],
  grey: "#b7bec7",
  lightGrey: "#f5f5f5",
  darkGrey: "#757575",
  white: "#fff",

  lightRed: red[300],
  red: red[500],
  darkRed: red[800],
};

let theme = createMuiTheme({
  palette: {
    primary: {
      light: colors.primaryLight,
      main: colors.primary,
      dark: colors.primaryDark,
    },
  },
  typography: {
    h5: {
      fontWeight: 500,
      fontSize: 26,
      letterSpacing: 0.5,
    },
  },
  // shape: {
  //   borderRadius: 8,
  // },
  props: {
    MuiTab: {
      disableRipple: true,
    },
  },
  mixins: {
    toolbar: {
      minHeight: 48,
    },
  },
});

theme = {
  ...theme,
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "*::-webkit-scrollbar": {
          width: "10px", // Largura da barra de rolagem
        },
        "*::-webkit-scrollbar-track": {
          background: "#f1f1f1", // Cor do fundo da trilha
        },
        "*::-webkit-scrollbar-thumb": {
          background: "#0a4b75",
          borderRadius: "100px",
        },
        "*::-webkit-scrollbar-thumb:hover": {
          background: "#555", // Cor do "polegar" ao passar o mouse
        },
      },
    },
    MuiDrawer: {
      paper: {
        backgroundColor: colors.drawer,
      },
    },
    MuiButton: {
      label: {
        textTransform: "none",
      },
      contained: {
        boxShadow: "none",
        "&:active": {
          boxShadow: "none",
        },
      },
    },
    MuiTabs: {
      root: {
        marginLeft: theme.spacing(1),
      },
      indicator: {
        height: 3,
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        backgroundColor: theme.palette.common.white,
      },
    },
    MuiTab: {
      root: {
        textTransform: "none",
        margin: "0 16px",
        minWidth: 0,
        padding: 0,
        [theme.breakpoints.up("md")]: {
          padding: 0,
          minWidth: 0,
        },
      },
    },
    MuiIconButton: {
      root: {
        padding: theme.spacing(1),
      },
    },
    MuiTooltip: {
      tooltip: {
        borderRadius: 4,
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: "#8ca315",
      },
    },
    MuiListItemText: {
      // primary: {
      //   fontWeight: theme.typography.fontWeightMedium
      // }
    },
    MuiListItemIcon: {
      root: {
        color: "inherit",
        marginRight: 0,
        "& svg": {
          fontSize: 20,
        },
      },
    },
    MuiAvatar: {
      root: {
        width: 32,
        height: 32,
      },
    },
  },
};

export default theme;
